import React from 'react';

export const initialState = {
  step: 1,
  operation: null,
  signed: false,
  user: {},
  contracts: [],
  confirmationData: {},
  photosUri: {
    front: null,
    back: null,
    neutralSelfie: null,
    specialSelfie: null,
    randomSelfie:null,
  },
  modal: {
    open: false,
    type: null,
    extraMessage: null,
  },
  camera: {
    open: false,
    type: null,
  },
  loading: false,
  error: {
    error: false,
    type: null,
    message: null,
  },
  notificate: {
    operationId: null,
    fileId: null
  }
};

const Context = React.createContext({ ...initialState });
Context.displayName = 'BankColumbiaStore';

export const useStore = () => React.useContext(Context);

export default Context;
